const colors = {
  green: '#4caf50',
  red: '#E91E63',
  yellow: 'yellow',
  orange: '#ff8d1e',
}

export default colors
